import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const PIN = '<svg class="s-access__pin-icon" width="36" height="46" viewBox="0 0 22 28" aria-hidden="true"><path fill="#102542" d="M11 27C11 27 21.2 16.8 21.2 10.4 21.2 4.6 16.6 0.6 11 0.6S0.8 4.6 0.8 10.4C0.8 16.8 11 27 11 27z"/><circle cx="11" cy="10.2" r="3.4" fill="#ffffff"/></svg>'

const GROUND = [246, 244, 241]
const ROAD = [255, 255, 255]
const BUILDING = [240, 232, 216]
const QUIET = [236, 233, 226]

const paint = (data, index, color) => {
  data[index] = color[0]
  data[index + 1] = color[1]
  data[index + 2] = color[2]
}

// Pastels du plan IGN : on ne garde que le sable des bâtiments et le gris du texte.
const tint = (data) => {
  for (let index = 0; index < data.length; index += 4) {
    const red = data[index]
    const green = data[index + 1]
    const blue = data[index + 2]
    const chroma = Math.max(red, green, blue) - Math.min(red, green, blue)

    if (chroma < 8) {
      continue
    }

    if (red > 200 && green > 175 && green - blue > 22 && red - blue > 28) {
      paint(data, index, ROAD)
      continue
    }

    if (red > 180 && red > green + 24 && red > blue + 24) {
      paint(data, index, BUILDING)
      continue
    }

    if (blue > green + 4 && red + 6 > green && blue - green > 6 && red > 150) {
      paint(data, index, GROUND)
      continue
    }

    if (blue > red + 6 && blue + 8 >= green) {
      paint(data, index, QUIET)
      continue
    }

    if (green > red + 2 && green > blue + 4) {
      paint(data, index, QUIET)
    }
  }
}

const Tiles = L.GridLayer.extend({
  createTile(coords, done) {
    const tile = document.createElement('canvas')
    const size = this.getTileSize()
    tile.width = size.x
    tile.height = size.y

    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.onload = () => {
      const context = tile.getContext('2d', { willReadFrequently: true })
      context.drawImage(image, 0, 0)
      const frame = context.getImageData(0, 0, tile.width, tile.height)
      tint(frame.data)
      context.putImageData(frame, 0, 0)
      done(null, tile)
    }
    image.onerror = () => done(new Error('tile'), tile)
    image.src = `https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&TILEMATRIX=${coords.z}&TILEROW=${coords.y}&TILECOL=${coords.x}`

    return tile
  },
})

export class AccessMap {
  constructor() {
    document.querySelectorAll('.s-access__map').forEach((map) => this.mount(map))
  }

  mount(element) {
    const lat = Number(element.dataset.lat)
    const lng = Number(element.dataset.lng)

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return
    }

    const map = L.map(element, {
      scrollWheelZoom: false,
      zoomControl: false,
      attributionControl: true,
    }).setView([lat, lng], 17)

    L.control.zoom({ position: 'topright' }).addTo(map)

    map.attributionControl.setPrefix(false)

    new Tiles({
      attribution: '&copy; <a href="https://www.ign.fr/">IGN</a>',
      maxZoom: 19,
    }).addTo(map)

    const label = element.dataset.label || ''
    const icon = L.divIcon({
      className: 's-access__pin',
      html: `<span class="s-access__pin-mark"><span class="s-access__pin-pulse"></span>${PIN}</span><span class="s-access__pin-label"></span>`,
      iconSize: [88, 88],
      iconAnchor: [44, 44],
    })
    const marker = L.marker([lat, lng], { icon, keyboard: false, title: label }).addTo(map)
    const labelNode = marker.getElement()?.querySelector('.s-access__pin-label')

    if (labelNode) {
      labelNode.textContent = label
    }

    if (window.matchMedia('(min-width: 1100px)').matches) {
      map.panBy([-200, 30], { animate: false })
    }

    requestAnimationFrame(() => map.invalidateSize())
  }
}
